import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OnePaymentOnAdvanceDocumentError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.payment-list-items.one-payment-on-advance-document');
    }
}
